/*jslint browser: true, plusplus: true */
(function ($, window, document) {
    'use strict';

    $(document).ready(function () {
        // output to the console log this file has been loaded
        console.log('afp-block-checkout.js loaded');
    });

}(jQuery, window, document));
